import type { IPostalAddress, PostalAddressApiPayload } from "../../customTypings/address/PostalAddress";
import { normalizePostcodeInput } from "../addressUtils";
import { emptyStringToNull, nullToEmptyString } from "./formValueNormalization";

export interface PostalAddressFormFields {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  town: string;
  county: string;
  postcode: string;
  country: string;
}

/** API → Formik: coerce null/undefined to "" for text inputs. */
export function hydratePostalAddressForForm(source: Partial<IPostalAddress>): PostalAddressFormFields {
  return {
    addressLine1: nullToEmptyString(source.addressLine1),
    addressLine2: nullToEmptyString(source.addressLine2),
    addressLine3: nullToEmptyString(source.addressLine3),
    town: nullToEmptyString(source.town),
    county: nullToEmptyString(source.county),
    postcode: normalizePostcodeInput(nullToEmptyString(source.postcode)),
    country: nullToEmptyString(source.country) || "United Kingdom",
  };
}

/** Form → API: blank optional fields become null; trimmed values otherwise. */
export function mapPostalAddressToApi(
    values: Partial<IPostalAddress> | PostalAddressFormFields,
): PostalAddressApiPayload {
  return {
    addressLine1: emptyStringToNull(nullToEmptyString(values.addressLine1).trim()),
    addressLine2: emptyStringToNull(values.addressLine2),
    addressLine3: emptyStringToNull(values.addressLine3),
    town: emptyStringToNull(values.town),
    county: emptyStringToNull(values.county),
    postcode: emptyStringToNull(normalizePostcodeInput(nullToEmptyString(values.postcode).trim())),
    country: emptyStringToNull(values.country),
  };
}
